var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.long)?_c('div',[_vm._v(" "+_vm._s(_vm.range)+" ")]):_c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.dimension.name)+" ")]),_vm._v(" ("+_vm._s(_vm.range)+") ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }